const Rwd    = require("../utillity/responsive");
const Utill  = require("../utillity/utill");


module.exports.ToggleVisible = function(order){
	if( order !== 'visible' && order !== 'unvisible' ) return;
	if( !$('body').hasClass('body--home') ) return;

	let nextState = order==='visible'? true: false;

	$('#gFooter').attr('data-visible', nextState);
};




// WEBPACK FOOTER //
// ./html/_src/js_wb/dom/footer.js